import * as z from 'zod';
import * as ACT from './actions/schemas';
import { SCRIPT_SCHEMA } from './scripting';
export * from './actions/schemas';
export const connectionKind = z.enum(['openapi']);
export const connectionSpec = z.object({
    name: z.string(),
    kind: connectionKind
});
export const openapiConnectionSpec = connectionSpec.extend({
    url: z.string(),
    baseUrl: z.string(),
    headers: z.record(z.any()).optional(),
    schema: z.record(z.any()).optional()
});
const anyValue = () => z.union([
    z.string(),
    z.number(),
    z.boolean(),
    z.null()
]);
export const RouteParamSpecSchema = z.object({
    name: z.string(),
    prop: z.string()
});
export const RoutePropSpecSchema = z.object({
    name: z.string(),
    value: z.any()
});
export const RouteSpecSchema = z.object({
    name: z.string(),
    path: z.string(),
    component: z.string(),
    componentProps: z.array(RoutePropSpecSchema).optional(),
    params: z.array(RouteParamSpecSchema).optional(),
    default: z.boolean().optional()
});
export const PageTabSpecSchema = z.object({
    title: z.union([z.string(), z.array(z.string())]),
    icon: z.string().optional(),
    tips: z.string().optional()
});
const DOMElementSpecSchema = z.lazy(() => z.object({
    id: z.string().optional(),
    tagName: z.string(),
    innerHTML: z.string().optional(),
    class: z.string().optional(),
    ref: z.string().optional(),
    slot: z.string().optional(),
    if: SCRIPT_SCHEMA().optional(),
    for: SCRIPT_SCHEMA().optional(),
    style: z
        .union([z.string(), z.record(z.any()), z.array(z.any())])
        .optional(),
    props: z.record(z.any()).optional(),
    attrs: z.record(z.any()).optional(),
    modal: z
        .object({
        placement: z.string(),
        command: z.string().optional()
    })
        .optional(),
    page: z.record(z.any()).optional(),
    events: z
        .array(z.lazy(() => ACT.EVENT_HANDLER_SPEC_SCHEMA_FACTORY()))
        .optional(),
    children: z.array(DOMElementSpecSchema).optional(),
    comments: z.string().optional()
}));
const ComponentPropertySpecSchema = z.object({
    name: z.string(),
    type: z.string(),
    required: z.boolean().optional(),
    default: z.any().optional(),
    clone: z.boolean().optional()
});
export const CACHE_TYPE_SCHEMA = z.enum(['local']);
const CacheConfigSpecSchema = z.object({
    type: CACHE_TYPE_SCHEMA.default('local'),
    key: z.any().default(null),
    onLoaded: SCRIPT_SCHEMA().optional()
});
const ComponentDataSpecSchema = z.object({
    name: z.string(),
    value: z.any().default(null),
    onChange: z.string().optional(),
    cache: CacheConfigSpecSchema.optional()
});
const ComponentClassVarSpecSchema = z.object({
    name: z.string(),
    value: z.any().default(null)
});
const ComponentMethodSpecSchema = z.object({
    name: z.string(),
    value: z.string()
});
const ComponentModalSize = z.enum(['sm', 'md', 'lg', 'xl', 'full-screen']);
const ComponentModalSpecSchema = z.object({
    size: ComponentModalSize.optional(),
    props: z.record(anyValue()).optional()
});
export const ComponentKindSchema = z.enum([
    'usercontrol',
    'page',
    'navigation',
    'modal'
]);
export const PLUGIN_KIND_SCHEMA = z.enum(['config', 'app']);
export const ERROR_HANDLING_MODE_SCHEMA = z.enum(['global', 'local']);
const COMPONENT_UX_SPEC_SCHEMA = z.object({
    errorHandling: ERROR_HANDLING_MODE_SCHEMA.optional(),
    initialLoadSpinner: z.boolean().optional(),
    initialLoadDelay: z.number().optional(),
    renderOnlyWhenLoadCompleted: z.boolean().optional()
});
const COMPONENT_PAGE_SPEC_SCHEMA = z.object({
    card: z.boolean().optional()
});
const COMPONENT_SPEC_SCHEMA = z.object({
    name: z.string(),
    kind: ComponentKindSchema,
    rootElement: z.string().optional(),
    ux: COMPONENT_UX_SPEC_SCHEMA.optional(),
    tagName: z.string().optional(),
    noWrap: z.boolean().optional(),
    content: z.array(DOMElementSpecSchema),
    modalOnly: z.boolean().optional(),
    modal: z.union([z.boolean(), ComponentModalSpecSchema]).optional(),
    page: COMPONENT_PAGE_SPEC_SCHEMA.optional(),
    data: z.array(ComponentDataSpecSchema).optional(),
    classVars: z.array(ComponentClassVarSpecSchema).optional(),
    subscriptions: z.array(ACT.SUBSCRIPTION_SPEC_SCHEMA).optional(),
    computed: z.array(ComponentMethodSpecSchema).optional(),
    methods: z.array(ComponentMethodSpecSchema).optional(),
    actions: z.array(ACT.ACTION_SPEC_SCHEMA).optional(),
    routes: z.array(RouteSpecSchema).optional(),
    properties: z.array(ComponentPropertySpecSchema).optional()
});
export const CONFIG_SPEC_SCHEMA = z.object({
    kind: z.literal('config'),
    name: z.string(),
    values: z.record(z.any())
});
export const PAGE_SPEC_SCHEMA = COMPONENT_SPEC_SCHEMA.extend({
    document: PageTabSpecSchema
});
export const COMPONENT_TEMPLATE_SPEC_SCHEMA = z.object({
    kind: z.literal('template'),
    interpolateVariables: z.boolean().optional(),
    name: z.string(),
    spec: z.union([z.array(z.record(z.any())), z.record(z.any())])
});
export const PLUGIN_COMPONENT_SPEC = CONFIG_SPEC_SCHEMA;
export const ANY_COMPONENT_SPEC = z.union([
    PAGE_SPEC_SCHEMA,
    COMPONENT_SPEC_SCHEMA
]);
export const APP_COMPONENT_SPEC_SCHEMA = z.union([
    PAGE_SPEC_SCHEMA,
    COMPONENT_SPEC_SCHEMA,
    COMPONENT_TEMPLATE_SPEC_SCHEMA
]);
export const APPLICATION_SCHEMA = z.object({
    name: z.string(),
    kind: z.literal('application'),
    specs: z.array(APP_COMPONENT_SPEC_SCHEMA)
});
//# sourceMappingURL=schemas.js.map